import { useEffect, useState } from 'react';

interface ConfirmATRCompletionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (completionAction: 'repaired' | 'received') => void;
    assetName: string;
}

export default function ConfirmATRCompletionModal({ isOpen, onClose, onConfirm, assetName }: ConfirmATRCompletionModalProps) {
    const [completionAction, setCompletionAction] = useState<'repaired' | 'received' | ''>('');

    useEffect(() => {
        if (isOpen) {
            setCompletionAction('');
        }
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-[100]">
            <div className="fixed inset-0 bg-black bg-opacity-50 z-[100]" onClick={onClose}></div>
            <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full mx-4 relative z-[101]">
                <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Confirm Completion</h2>
                <p className="text-gray-700 dark:text-gray-300 mb-6">
                    Are you sure you want to mark "<i className="font-semibold">{assetName}</i>" as completed? <br/><br/> 
                    A task will be automatically created for this completion. This action cannot be undone.
                </p>
                <div className="mb-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                    <p className="text-sm text-blue-700 dark:text-blue-300">
                        <strong>Note:</strong> A job card task will be automatically created when this ATR item is completed.
                    </p>
                </div>
                <div className="mb-6">
                    <label htmlFor="atr-completion-action" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Completion Result <span className="text-red-500">*</span>
                    </label>
                    <select
                        id="atr-completion-action"
                        value={completionAction}
                        onChange={(e) => setCompletionAction(e.target.value as 'repaired' | 'received' | '')}
                        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                    >
                        <option value="">-- Select result --</option>
                        <option value="repaired">Repaired</option>
                        <option value="received">Received</option>
                    </select>
                </div>
                <div className="flex justify-end gap-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors duration-200"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => {
                            if (!completionAction) {
                                return;
                            }
                            onConfirm(completionAction);
                            onClose();
                        }}
                        disabled={!completionAction}
                        className="px-4 py-2 text-white bg-green-600 dark:bg-green-500 rounded-lg hover:bg-green-700 dark:hover:bg-green-600 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        Complete
                    </button>
                </div>
            </div>
        </div>
    );
}